import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import ItemDetails from './item-details'
import Items from './items'
import Button from '~/components/common/button'

import { translate } from '~/core/translate'
import { addRecordToMeeting, retrieveRecents } from '~/actions/salesforce'
import { hideDialog } from '~/actions/ui'
import Modal from '~/components/common/modal'

const Add = () => {
  const [notes, setNotes] = useState('')
  const [selectedId, setSelectedId] = useState(null)
  const dispatch = useDispatch()

  const handleItemSelected = useCallback(id => {
    setSelectedId(id)
  }, [])

  const close = useCallback(() => {
    setSelectedId(null)
  }, [])

  const add = useCallback(() => {
    dispatch(addRecordToMeeting({ notes, recordId: selectedId }))
    hideDialog()
  }, [dispatch, notes, selectedId])

  const handleNotesChange = useCallback(evt => {
    setNotes(evt.target.value)
  }, [])

  const footerChildren = useMemo(() => selectedId && (
    <>
      <Button onClick={close} variant='tertiary'>{translate('cancel')}</Button>
      <Button onClick={add}>{translate('salesforce_add')}</Button>
    </>
  ), [selectedId])

  useEffect(() => {
    dispatch(retrieveRecents())
  }, [dispatch])

  return (
    <Modal
      footerChildren={footerChildren}
      title={translate('salesforce_add_meeting')}
    >
      {selectedId
        ? (
          <ItemDetails
            recordId={selectedId}
            onNotesChange={handleNotesChange}
            notes={notes}
          />
          )
        : <Items onItemSelected={handleItemSelected} />}
    </Modal>
  )
}

export default Add
